import { useQuery } from '@tanstack/react-query';
import { API_TAGS } from '@/shared/api';
import { fetchThemeConfig } from './api';
import type { ProjectConfigResponse } from './types';

/** Query-ключи для запросов настроек проекта */
export const settingsKeys = {
  /** Корневой ключ всех запросов настроек */
  all: [API_TAGS.SETTINGS] as const,
  /** Ключ запроса конфигурации тем проекта */
  themeConfig: () => [...settingsKeys.all, 'themeConfig'] as const,
};

/**
 * Хук для получения конфигурации проекта (темы в формате ProjectConfigResponse)
 *
 * @returns Query объект с данными (themes — массив, colorParameter с code в snake_case)
 */
export const useThemeConfig = () => {
  return useQuery<ProjectConfigResponse>({
    queryKey: settingsKeys.themeConfig(),
    queryFn: fetchThemeConfig,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
